import React from 'react';

import { Typography } from '@sravni/react-design-system';
import { useIsMobile } from '@sravni/react-utils';

type TPanelHeaderProps = {
  branchName: string;
};

export const PanelHeader = ({ branchName }: TPanelHeaderProps) => {
  const isMobile = useIsMobile();

  return <Typography.Heading level={isMobile ? 4 : 6}>{branchName}</Typography.Heading>;
};
